import React from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import AutoCompleteItem from "../../../components/forms/AutoCompleteItem";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";

const Address = () => {
  return (
    <ChildrenAnimationWrapper>
      <Row>
        <Col span={11}>
          <AnimationChildWrapper itemKey={1}>
            <AutoCompleteItem
              required={true}
              name="address.city"
              category="branch"
              city={true}
            />
            <AnimationChildWrapper itemKey={2}>
              <InputItem
                required={true}
                name="address.house_number"
                category="branch"
              />
            </AnimationChildWrapper>
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={3}>
            <InputItem name="mailbox_number" category="branch" />
          </AnimationChildWrapper>
        </Col>
        <Col span={11} offset={2}>
          <AnimationChildWrapper itemKey={4}>
            <InputItem
              required={true}
              name="address.street"
              category="branch"
            />
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={5}>
            <InputItem
              name="address.postal_code"
              postalCode={true}
              category="branch"
            />
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={6}></AnimationChildWrapper>
        </Col>
      </Row>
    </ChildrenAnimationWrapper>
  );
};

export default Address;
